import pubsub from 'sweet-pubsub';
import { AmplitudeLogger, EVENTS, pickOutInitials } from "../utils";
import sessionStore from '../../store/session';
import callStore from '../../store/call';
import { get } from 'svelte/store';
import { createCall, setActiveNumber, setCallRecordID } from '../../domain/provider/zoho.action';
export const useCti = () => {
    const defaultSize = { width: 320, height: 460 };
    let phoneNumber = null;
    let call_record_id = null;
    ZOHO.embeddedApp.on('Dial', function (data) {
        // console.log(data);
        phoneNumber = data.Number;
        pubsub.emit('initiate_call', data.Number);
        ZOHO.CRM.UI.Dialer.maximize();
    });
    const zohoInit = ZOHO.embeddedApp
        .init();
    zohoInit.then(function () {
        console.log(">>>>>>>> Pressone ZOHO initialized >>>>>>>>>");
    })
        .catch(function (_) {
        console.log('Error');
    });
    const saveCallLog = async (number, duration, direction, call_id = null, callResult = null) => {
        let date_split = (new Date(new Date().getTime() + 3600 * 1000)).toISOString().split('T');
        let datetime = date_split[0] + 'T' + date_split[1].split('.')[0];
        let module = 'Contacts';
        let recordData = {
            Call_Type: direction,
            Call_Start_Time: datetime,
            Call_Duration: String(duration),
            Description: `Dialed number ${number}`,
            Dialled_Number: String(number),
            Caller_ID: String(number),
            $se_module: module,
            CTI_Entry: 'PressOne-Widget',
            Call_Result: callResult !== null ? callResult : direction,
            // Outgoing_Call_Status: '',
            Voice_Recording__s: `https://storage.googleapis.com/pressonedotco/voice-message-recordings/${call_id}.wav`,
            // Owner: ''
        };
        async function setContactDetails(module, number) {
            try {
                let { id, name, accountName } = await searchContact(module, number);
                return { id, name, accountId: (accountName === null || accountName === void 0 ? void 0 : accountName.id) || null };
            }
            catch (_a) {
                return null;
            }
        }
        try {
            const contactDetails = await setContactDetails(recordData.$se_module, number);
            recordData.Who_Id = contactDetails.id;
            recordData.Subject = `Call with ${contactDetails.name}`;
            if (contactDetails.accountId) {
                recordData.$se_module = 'Accounts';
                recordData.What_Id = contactDetails.accountId;
            }
        }
        catch (_) {
            try {
                recordData.$se_module = 'Leads';
                const contactDetails = await setContactDetails(recordData.$se_module, number);
                recordData.What_Id = contactDetails.id;
                recordData.Subject = `Call with ${contactDetails.name}`;
            }
            catch (error) {
                recordData.$se_module = 'Calls';
                recordData.Subject = `Call with ${number}`;
            }
        }
        // try {
        //     let { id, name, accountName } = await searchContact(recordData.$se_module, number)
        //     recordData.Who_Id = id;
        //     recordData.Subject = `Call with ${name}`;
        // } catch (_) {
        //     try {
        //         recordData.$se_module = 'Leads';
        //         let { id, name, accountName } = await searchContact(recordData.$se_module, number)
        //         recordData.What_Id = id;
        //         recordData.Subject = `Call with ${name}`;
        //     } catch (error) {
        //         recordData.$se_module = 'Calls';
        //         recordData.Subject = `Call with ${number}`;
        //     }
        // }
        const { data = [] } = await ZOHO.CRM.API.insertRecord({
            Entity: 'Calls',
            APIData: recordData,
        });
        return data[0].details.id;
    };
    const searchContact = async (entity, phone) => {
        if (!phone) {
            throw new Error("phone is compulsory");
        }
        let query = phone.startsWith('234') ?
            `(Phone:equals:${phone}) or (Mobile:equals:${phone})` :
            `(Phone:equals:${phone}) or (Phone:equals:+${phone}) or (Mobile:equals:${phone}) or (Mobile:equals:+${phone})`;
        const { data } = await ZOHO.CRM.API.searchRecord({
            Entity: entity,
            Type: 'criteria',
            Query: query,
        });
        if (data && data.length > 0) {
            let result = { id: data[0].id, name: data[0].Full_Name };
            if (entity === "Contacts") {
                result.accountName = data[0].Account_Name;
            }
            else {
                result.accountName = null;
            }
            return result;
        }
        throw new Error("record not found");
        ;
    };
    const saveNote = async (record_id, note) => {
        return await ZOHO.CRM.API.addNotes({
            Entity: 'Calls',
            RecordID: record_id,
            Title: 'Call Notes',
            Content: note,
        });
    };
    const updateCallInfo = async (phone) => {
        let __name__;
        try {
            let { name } = await searchContact("Contacts", phone);
            __name__ = name;
        }
        catch (error) {
            try {
                let { name } = await searchContact("Leads", phone);
                __name__ = name;
            }
            catch (_) { }
        }
        if (__name__) {
            callStore.update({
                peerName: __name__,
                peerInitials: pickOutInitials(__name__)
            });
        }
    };
    pubsub.on('login', ({ mobile, email, first_name, last_name }) => {
        AmplitudeLogger.log(EVENTS.LOGIN, { mobile, email, first_name, last_name });
        if (phoneNumber) {
            pubsub.emit('initiate_call', phoneNumber);
        }
    });
    pubsub.on('number_selected', async ({ number }) => {
        AmplitudeLogger.log(EVENTS.NUMBER_SELECTED, { number: phoneNumber });
        console.log('NUMBER_SELECTED');
        if (number) {
            await setActiveNumber(number);
        }
        if (phoneNumber) {
            pubsub.emit('initiate_call', phoneNumber);
        }
    });
    pubsub.on('call_started', async ({ direction, peer, call_sip_id }) => {
        console.log('CALL_PICKED');
        // console.log(peer)
        const callStartTime = Date.now();
        const { receiver } = get(sessionStore);
        const payload = {
            createEngagement: true,
            callStartTime,
            toNumber: peer,
            fromNumber: receiver.business_number.phone_number,
            phoneNumber
        };
        AmplitudeLogger.log(EVENTS.CALL_STARTED, payload);
        await createCall(call_sip_id);
    });
    pubsub.on('call_missed', async ({ peer: phoneNumber, call_sip_id }) => {
        console.log('CALL_MISSED');
        // console.log(phoneNumber)
        call_record_id = null;
        call_record_id = await saveCallLog(phoneNumber, 0, "Missed", call_sip_id, "Missed");
        try {
            if (get(sessionStore).has_done_oauth_link && call_sip_id && call_record_id) {
                await setCallRecordID(call_sip_id, call_record_id, "");
            }
        }
        catch (e) { }
    });
    pubsub.on('call_ended', async ({ direction, peer, duration, notes, call_sip_id }) => {
        console.log('CALL_ENDED');
        // console.log(peer)
        AmplitudeLogger.log(EVENTS.CALL_ENDED, { direction, peer, duration, notes });
        call_record_id = null;
        call_record_id = await saveCallLog(peer, duration, direction, call_sip_id, direction === "Missed" ? direction : "Completed");
        try {
            if (get(sessionStore).has_done_oauth_link && call_sip_id && call_record_id) {
                await setCallRecordID(call_sip_id, call_record_id, notes);
            }
        }
        catch (e) { }
        if (notes && !get(callStore).takeNote) {
            try {
                await saveNote(call_record_id, notes);
            }
            catch (e) { }
        }
    });
    pubsub.on('call_ringing', async ({ peer: fromNumber, call_sip_id }) => {
        console.log('INCOMING_CALL');
        AmplitudeLogger.log(EVENTS.RINGING, { fromNumber });
        ZOHO.CRM.UI.Dialer.maximize();
        await updateCallInfo(fromNumber);
        if (call_sip_id)
            await createCall(call_sip_id);
    });
    pubsub.on('call_initiated', async ({ peer: fromNumber, call_sip_id }) => {
        console.log('INITIATED_CALL');
        AmplitudeLogger.log(EVENTS.INIT_CALL, { fromNumber });
        ZOHO.CRM.UI.Dialer.maximize();
        await updateCallInfo(fromNumber);
        if (call_sip_id)
            await createCall(call_sip_id);
    });
    pubsub.on('call_note_save', async ({ notes }) => {
        if (call_record_id) {
            await saveNote(call_record_id, notes);
        }
    });
    pubsub.on('logout', () => {
    });
    return {
        API: ZOHO.CRM.API,
        UI: ZOHO.CRM.UI,
        DIALER: ZOHO.CRM.UI.Dialer,
        CONFIG: ZOHO.CRM.CONFIG,
        META: ZOHO.CRM.META,
    };
};
